export const calculateCommission = (transactionType, amount, monthlyRent = 0) => {
    let commission = 0;
    let finalAmount;
    let commissionRate;
    let commissionLimit;
    amount *= 10000;
    monthlyRent *= 10000;

    // 1. 거래금액(계산기준금액) 산정
    if (transactionType === '월세') {
        // 월세 계산 로직
        const calculatedAmount = amount + (monthlyRent * 100);
        if (calculatedAmount < 50000000) {
            finalAmount = amount + (monthlyRent * 70);
        } else {
            finalAmount = calculatedAmount;
        }
    } else {
        // 매매, 전세 계산 로직
        finalAmount = amount;
    }

    // 2. 거래유형에 따른 상한요율 및 한도액 적용
    if (transactionType === '매매') {
        if (finalAmount < 50000000) {
            commissionRate = 0.006; // 0.6%
            commissionLimit = 250000;
        } else if (finalAmount < 200000000) {
            commissionRate = 0.005; // 0.5%
            commissionLimit = 800000;
        } else if (finalAmount < 900000000) {
            commissionRate = 0.004; // 0.4%
            commissionLimit = null; // 한도액 없음
        } else if (finalAmount < 1200000000) {
            commissionRate = 0.005; // 0.5%
            commissionLimit = null;
        } else if (finalAmount < 1500000000) {
            commissionRate = 0.006; // 0.6%
            commissionLimit = null;
        } else {
            commissionRate = 0.007; // 0.7%
            commissionLimit = null;
        }
    } else if (transactionType === '전세' || transactionType === '월세') {
        if (finalAmount < 50000000) {
            commissionRate = 0.005; // 0.5%
            commissionLimit = 200000;
        } else if (finalAmount < 100000000) {
            commissionRate = 0.004; // 0.4%
            commissionLimit = 300000;
        } else if (finalAmount < 600000000) {
            commissionRate = 0.003; // 0.3%
            commissionLimit = null;
        } else if (finalAmount < 1200000000) {
            commissionRate = 0.004; // 0.4%
            commissionLimit = null;
        } else if (finalAmount < 1500000000) {
            commissionRate = 0.005; // 0.5%
            commissionLimit = null;
        } else {
            commissionRate = 0.006; // 0.6%
            commissionLimit = null;
        }
    }

    // 3. 최종 중개수수료 계산
    commission = finalAmount * commissionRate;
    if (commissionLimit !== null && commission > commissionLimit) {
        commission = commissionLimit;
    }

    return {
        commissionRate: commissionRate * 100,
        commissionLimit: commissionLimit,
        commission: commission,
    };
};